import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import './LegalPages.css';

function Terms() {
  const { t } = useTranslation();
  const lastUpdated = t('terms.lastUpdated');

  // Scrolla till toppen när sidan laddas
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="legal-container">
        <div className="legal-header">
          <h1>{t('terms.title')}</h1>
          <p className="last-updated">{t('terms.lastUpdatedLabel')} {lastUpdated}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t('terms.sections.general.title')}</h2>
            <p>{t('terms.sections.general.p1')}</p>
            <p>{t('terms.sections.general.p2')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.account.title')}</h2>
            <h3>{t('terms.sections.account.requirements.title')}</h3>
            <ul>
              <li>{t('terms.sections.account.requirements.li1')}</li>
              <li>{t('terms.sections.account.requirements.li2')}</li>
              <li>{t('terms.sections.account.requirements.li3')}</li>
              <li>{t('terms.sections.account.requirements.li4')}</li>
            </ul>

            <h3>{t('terms.sections.account.responsibility.title')}</h3>
            <p>{t('terms.sections.account.responsibility.intro')}</p>
            <ul>
              <li>{t('terms.sections.account.responsibility.li1')}</li>
              <li>{t('terms.sections.account.responsibility.li2')}</li>
              <li>{t('terms.sections.account.responsibility.li3')}</li>
              <li>{t('terms.sections.account.responsibility.li4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.usage.title')}</h2>
            <h3>{t('terms.sections.usage.allowed.title')}</h3>
            <p>{t('terms.sections.usage.allowed.intro')}</p>
            <ul>
              <li>{t('terms.sections.usage.allowed.li1')}</li>
              <li>{t('terms.sections.usage.allowed.li2')}</li>
              <li>{t('terms.sections.usage.allowed.li3')}</li>
            </ul>

            <h3>{t('terms.sections.usage.prohibited.title')}</h3>
            <p>{t('terms.sections.usage.prohibited.intro')}</p>
            <ul>
              <li>{t('terms.sections.usage.prohibited.li1')}</li>
              <li>{t('terms.sections.usage.prohibited.li2')}</li>
              <li>{t('terms.sections.usage.prohibited.li3')}</li>
              <li>{t('terms.sections.usage.prohibited.li4')}</li>
              <li>{t('terms.sections.usage.prohibited.li5')}</li>
              <li>{t('terms.sections.usage.prohibited.li6')}</li>
              <li>{t('terms.sections.usage.prohibited.li7')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.subscriptions.title')}</h2>
            <h3>{t('terms.sections.subscriptions.free.title')}</h3>
            <ul>
              <li>{t('terms.sections.subscriptions.free.li1')}</li>
              <li>{t('terms.sections.subscriptions.free.li2')}</li>
              <li>{t('terms.sections.subscriptions.free.li3')}</li>
            </ul>

            <h3>{t('terms.sections.subscriptions.premium.title')}</h3>
            <ul>
              <li>{t('terms.sections.subscriptions.premium.li1')}</li>
              <li>{t('terms.sections.subscriptions.premium.li2')}</li>
              <li>{t('terms.sections.subscriptions.premium.li3')}</li>
              <li>{t('terms.sections.subscriptions.premium.li4')}</li>
            </ul>

            <h3>{t('terms.sections.subscriptions.payment.title')}</h3>
            <ul>
              <li>{t('terms.sections.subscriptions.payment.li1')}</li>
              <li>{t('terms.sections.subscriptions.payment.li2')}</li>
              <li>{t('terms.sections.subscriptions.payment.li3')}</li>
              <li>{t('terms.sections.subscriptions.payment.li4')}</li>
            </ul>

            <h3>{t('terms.sections.subscriptions.priceChanges.title')}</h3>
            <p>{t('terms.sections.subscriptions.priceChanges.p1')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.intellectual.title')}</h2>
            <p>{t('terms.sections.intellectual.p1')}</p>
            <p>{t('terms.sections.intellectual.p2')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.termination.title')}</h2>
            <h3>{t('terms.sections.termination.userRight.title')}</h3>
            <p>{t('terms.sections.termination.userRight.p1')}</p>

            <h3>{t('terms.sections.termination.ourRight.title')}</h3>
            <p>{t('terms.sections.termination.ourRight.intro')}</p>
            <ul>
              <li>{t('terms.sections.termination.ourRight.li1')}</li>
              <li>{t('terms.sections.termination.ourRight.li2')}</li>
              <li>{t('terms.sections.termination.ourRight.li3')}</li>
              <li>{t('terms.sections.termination.ourRight.li4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.liability.title')}</h2>
            <p>{t('terms.sections.liability.intro')}</p>
            <ul>
              <li>{t('terms.sections.liability.li1')}</li>
              <li>{t('terms.sections.liability.li2')}</li>
              <li>{t('terms.sections.liability.li3')}</li>
              <li>{t('terms.sections.liability.li4')}</li>
            </ul>
            
            <p className="highlight-box">
              <strong>{t('terms.sections.liability.important.title')}</strong> {t('terms.sections.liability.important.text')}
            </p>

            <p>{t('terms.sections.liability.limitation')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.changes.title')}</h2>
            <p>{t('terms.sections.changes.intro')}</p>
            <ul>
              <li>{t('terms.sections.changes.li1')}</li>
              <li>{t('terms.sections.changes.li2')}</li>
            </ul>
            <p>{t('terms.sections.changes.acceptance')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.forceMajeure.title')}</h2>
            <p>{t('terms.sections.forceMajeure.p1')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.disputes.title')}</h2>
            <p>{t('terms.sections.disputes.p1')}</p>
            <p>{t('terms.sections.disputes.p2')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.contact.title')}</h2>
            <p>{t('terms.sections.contact.intro')}</p>
            <div className="contact-box">
              <p><strong>{t('terms.sections.contact.email')}</strong> support@moricome.com</p>
              <p><strong>{t('terms.sections.contact.website')}</strong> www.moricome.com</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>{t('terms.sections.misc.title')}</h2>
            <ul>
              <li>
                <strong>{t('terms.sections.misc.assignment.title')}</strong> {t('terms.sections.misc.assignment.text')}
              </li>
              <li>
                <strong>{t('terms.sections.misc.severability.title')}</strong> {t('terms.sections.misc.severability.text')}
              </li>
              <li>
                <strong>{t('terms.sections.misc.entireAgreement.title')}</strong> {t('terms.sections.misc.entireAgreement.text')}
              </li>
            </ul>
          </section>

          <div className="legal-footer">
            <p>
              {t('terms.footer.p1')} <Link to="/privacy">{t('terms.footer.privacyLink')}</Link>.
            </p>
          </div>
        </div>

        <div className="back-link">
          <Link to="/hur">{t('terms.backLink')}</Link>
        </div>
      </div>
    </>
  );
}

export default Terms;